var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEdit = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2rem",
    height: "1.2rem",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89299 4.41771L9.2752 6.14849L4.85157 12.2371L2.38435 13.1281L2.46937 10.5063L6.89299 4.41771ZM7.48077 3.6087L9.86298 5.33947L10.8181 4.02492L8.43585 2.29414L7.48077 3.6087ZM10.3781 6.33177L10.672 5.92726L11.6271 4.6127L12.2149 3.80369L11.4058 3.2159L9.02364 1.48512L8.21462 0.897339L7.62684 1.70636L6.67176 3.02091L6.37786 3.42542L6.08397 3.82993L1.47984 10.167L1.37197 13.4937L1.33708 14.5696L2.34946 14.2039L5.48009 13.0733L10.0842 6.73627L10.3781 6.33177ZM6 15H14V14H6V15Z",
    fill: "black"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.61f26c4e.svg";
export { ForwardRef as ReactComponent };